let filler
export function usePayloadFiller () {
  function setFiller () {
    if (!filler) {
      filler = process.env.VUE_APP_IDONIA_UI_TOKEN
    }
  }
  function getStringPayload (payload = '') {
    return payload + filler + (window.location.origin || window.origin)
  }
  return {
    setFiller,
    getStringPayload
  }
}



// WEBPACK FOOTER //
// ./src/commons/payloadFiller.js